/**
 * Single source of truth for public (unauthenticated) application paths.
 * Used by middleware, Layout, auth and api layers — keep in sync.
 */

const PUBLIC_PATHS = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/nicov',
  '/support',
  '/shop',
  '/sitemap.xml',
  '/robots.txt',
  '/pwtest.html',
  '/reset-password-credential-save',
  '/pujcsiminibus',
];

const PUBLIC_PREFIXES = [
  '/book/',
  '/bookings/',
  '/support/track/',
  '/public/',
  '/nicov/',
  '/shop/',
  '/pujcsiminibus/',
];

export function isPublicPath(pathname: string): boolean {
  if (PUBLIC_PATHS.includes(pathname)) return true;
  return PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
